/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfGetMapsPostalCodesByCityAndStateIdDto } from '../models/custom-result-of-get-maps-postal-codes-by-city-and-state-id-dto';
import { CustomResultOfPaginatedListOfGetMapsPostalCodesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-maps-postal-codes-with-pagination-dto';
import { mapsPostalCodesCreateGet } from '../fn/maps-postal-codes/maps-postal-codes-create-get';
import { MapsPostalCodesCreateGet$Params } from '../fn/maps-postal-codes/maps-postal-codes-create-get';
import { mapsPostalCodesCreatePost } from '../fn/maps-postal-codes/maps-postal-codes-create-post';
import { MapsPostalCodesCreatePost$Params } from '../fn/maps-postal-codes/maps-postal-codes-create-post';
import { mapsPostalCodesDelete } from '../fn/maps-postal-codes/maps-postal-codes-delete';
import { MapsPostalCodesDelete$Params } from '../fn/maps-postal-codes/maps-postal-codes-delete';
import { mapsPostalCodesGetMapsPostalCodesByStateAndCityId } from '../fn/maps-postal-codes/maps-postal-codes-get-maps-postal-codes-by-state-and-city-id';
import { MapsPostalCodesGetMapsPostalCodesByStateAndCityId$Params } from '../fn/maps-postal-codes/maps-postal-codes-get-maps-postal-codes-by-state-and-city-id';
import { mapsPostalCodesGetMapsPostalCodesWithPagination } from '../fn/maps-postal-codes/maps-postal-codes-get-maps-postal-codes-with-pagination';
import { MapsPostalCodesGetMapsPostalCodesWithPagination$Params } from '../fn/maps-postal-codes/maps-postal-codes-get-maps-postal-codes-with-pagination';

@Injectable({ providedIn: 'root' })
export class MapsPostalCodesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mapsPostalCodesCreateGet()` */
  static readonly MapsPostalCodesCreateGetPath = '/MapsPostalCodes/Create';

  /**
   * برای دسترسی.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapsPostalCodesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesCreateGet$Response(params?: MapsPostalCodesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mapsPostalCodesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * برای دسترسی.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapsPostalCodesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesCreateGet(params?: MapsPostalCodesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.mapsPostalCodesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `mapsPostalCodesCreatePost()` */
  static readonly MapsPostalCodesCreatePostPath = '/MapsPostalCodes/Create';

  /**
   * Create MapsPostalCode.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapsPostalCodesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mapsPostalCodesCreatePost$Response(params: MapsPostalCodesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return mapsPostalCodesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create MapsPostalCode.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapsPostalCodesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mapsPostalCodesCreatePost(params: MapsPostalCodesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.mapsPostalCodesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `mapsPostalCodesDelete()` */
  static readonly MapsPostalCodesDeletePath = '/MapsPostalCodes/{id}';

  /**
   * Delete MapsPostalCode.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapsPostalCodesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesDelete$Response(params: MapsPostalCodesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return mapsPostalCodesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete MapsPostalCode.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapsPostalCodesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesDelete(params: MapsPostalCodesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.mapsPostalCodesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `mapsPostalCodesGetMapsPostalCodesWithPagination()` */
  static readonly MapsPostalCodesGetMapsPostalCodesWithPaginationPath = '/MapsPostalCodes/GetMapsPostalCodesWithPagination';

  /**
   * Get MapsPostalCodes with paging.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapsPostalCodesGetMapsPostalCodesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mapsPostalCodesGetMapsPostalCodesWithPagination$Response(params: MapsPostalCodesGetMapsPostalCodesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetMapsPostalCodesWithPaginationDto>> {
    return mapsPostalCodesGetMapsPostalCodesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get MapsPostalCodes with paging.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapsPostalCodesGetMapsPostalCodesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  mapsPostalCodesGetMapsPostalCodesWithPagination(params: MapsPostalCodesGetMapsPostalCodesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetMapsPostalCodesWithPaginationDto> {
    return this.mapsPostalCodesGetMapsPostalCodesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetMapsPostalCodesWithPaginationDto>): CustomResultOfPaginatedListOfGetMapsPostalCodesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `mapsPostalCodesGetMapsPostalCodesByStateAndCityId()` */
  static readonly MapsPostalCodesGetMapsPostalCodesByStateAndCityIdPath = '/MapsPostalCodes/GetMapsPostalCodesByStateAndCityId';

  /**
   * Get Maps Postal Codes By State And City Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mapsPostalCodesGetMapsPostalCodesByStateAndCityId()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesGetMapsPostalCodesByStateAndCityId$Response(params?: MapsPostalCodesGetMapsPostalCodesByStateAndCityId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetMapsPostalCodesByCityAndStateIdDto>> {
    return mapsPostalCodesGetMapsPostalCodesByStateAndCityId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Maps Postal Codes By State And City Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mapsPostalCodesGetMapsPostalCodesByStateAndCityId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mapsPostalCodesGetMapsPostalCodesByStateAndCityId(params?: MapsPostalCodesGetMapsPostalCodesByStateAndCityId$Params, context?: HttpContext): Observable<CustomResultOfGetMapsPostalCodesByCityAndStateIdDto> {
    return this.mapsPostalCodesGetMapsPostalCodesByStateAndCityId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetMapsPostalCodesByCityAndStateIdDto>): CustomResultOfGetMapsPostalCodesByCityAndStateIdDto => r.body)
    );
  }

}
